import { render, staticRenderFns } from "./FormerYearOchart.vue?vue&type=template&id=65fd5176&scoped=true&"
import script from "./FormerYearOchart.vue?vue&type=script&lang=js&"
export * from "./FormerYearOchart.vue?vue&type=script&lang=js&"
import style0 from "./FormerYearOchart.vue?vue&type=style&index=0&lang=css&"
import style1 from "../../statistics/css/departmentOchart.css?vue&type=style&index=1&id=65fd5176&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fd5176",
  null
  
)

export default component.exports